<template>
  <vs-popup
    :title="titlePopUp"
    :active.sync="activatingPopUp"
    @close="closeWithLoad(false)"
    class="p-5"
  >
    <main class="mt-2 w-full">
      <div class="mb-6" v-if="!disablelity">
        <section class="mb-4 flex justify-start gap-1">
          <h6><strong>Pilih Pemilik Referal</strong></h6>
          <span class="text-danger">*</span>
        </section>
        <v-select
          :options="referals"
          class="w-full"
          :reduce="(v) => v.id"
          v-validate="'required'"
          data-vv-validate-on="blur"
          name="referal"
          label="name"
          v-model="formData.referal_id"
          placeholder="Pilih Pemilik Referal"
        />
        <span class="text-danger text-sm">{{ errors.first("referal") }}</span>
      </div>
      <div class="mb-6" v-else>
        <p class="text-lg text-danger">
          Pemilik referal ini sudah diatur di admin, pemilik tidak bisa di atur di Sahabat
          ZX. Silahkan hubungi admin untuk tindakan lebih lanjut
        </p>
      </div>
    </main>
    <footer class="mt-4" v-if="!disablelity">
      <div class="flex justify-end items-center mr-4 mb-4">
        <vs-button color="danger" class="mr-2 rounded-2xl" @click="closeWithLoad(false)"
          >Cancel</vs-button
        >
        <vs-button
          color="success"
          class="ml-2 rounded-2xl"
          :disabled="!validateForm"
          @click="addData"
          >{{ labelButton }}</vs-button
        >
      </div>
    </footer>
  </vs-popup>
</template>
<script>
import flatPickr from "vue-flatpickr-component";
import "flatpickr/dist/flatpickr.css";
import emptyImage from "@/assets/images/elements/empty.png";
import url from "@/url.js";

export default {
  components: {
    flatPickr,
  },
  props: {
    campaignId: null,
    activate: { type: Boolean, default: false },
    passData: { type: Object, default: null },
  },
  data() {
    return {
      emptyImage,
      url,
      formData: {
        referal_id: "",
        campaign_id: "",
      },
    };
  },
  computed: {
    titlePopUp() {
      return this.passData != null ? "Edit Kode Referal" : "Tambah Kode Referal";
    },
    labelButton() {
      return this.passData != null ? "Edit" : "Submit";
    },
    validateForm() {
      return !this.errors.any() && this.formData.referal_id !== "";
    },
    referals() {
      return this.$store.state.referal.referalList;
    },
    disablelity() {
      if (this.passData !== null) {
        return this.referals.find((v) => v.id == this.passData.referal.id) === undefined;
      }

      return false;
    },
    profile() {
      return this.$store.state.auth.profileAccess.profile;
    },
    activatingPopUp: {
      get() {
        return this.activate;
      },
      set(val) {
        this.$emit("callback", val);
      },
    },
  },
  watch: {
    activate() {
      if (this.passData !== null) {
        this.formData.referal_id = this.passData.referal ? this.passData.referal.id : "";
      } else {
        this.resetForm();
      }
    },
  },
  methods: {
    resetForm() {
      this.formData.referal_id = "";
      this.formData.campaign_id = "";
    },
    closeWithLoad(load) {
      this.activatingPopUp = false;
      this.$emit("withClose", load);
    },
    addData() {
      this.$vs.loading({
        color: "primary",
      });
      let id = {};
      if (this.passData !== null) {
        id = {
          id: this.passData.id,
        };
      }

      // if (this.checkCategory) {
      //   this.formData.kat_id = this.$store.state.zis.kategoriList.find(
      //     (v) => v.name === "Zakat" || v.name === "Zakat Fitrah"
      //   ).id;
      //   this.formData.sub_id = this.$store.state.zis.subKategoriList.find(
      //     (v) => v.name === "Zakat Fitrah"
      //   ).id;
      // }
      this.formData.campaign_id = this.campaignId.toString();
      this.formData.user_id = this.profile.id;
      this.$store
        .dispatch("referal/cudReferalCampaign", [{ ...this.formData, ...id }])
        .then((v) => {
          this.$vs.loading.close();
          this.$vs.notify({
            position: "top-right",
            title:
              this.passData !== null ? "Edit Referal Sukses!" : "Tambah Referal Sukses!",
            text:
              this.passData !== null
                ? `Referal Berhasil diedit`
                : `Referal Berhasil ditambah`,
            iconPack: "feather",
            icon: "icon-smile",
            color: "primary",
          });

          this.closeWithLoad(true);
        })
        .catch((e) => {
          this.$vs.loading.close();
          if (e.response) {
            console.error(e.response.status);
            this.$vs.notify({
              position: "top-right",
              title: "Oops!",
              text: e.response.data.message,
              iconPack: "feather",
              icon: "icon-alert-circle",
              color: "danger",
            });
          }
        })
        .finally(() => {
          this.resetForm();
        });
    },
  },
};
</script>

<style scoped>
.text-red {
  color: red;
}
.text-blue {
  color: blue;
}
.text-grey-black {
  color: rgb(70, 70, 70);
}
img {
  max-height: 400px;
  overflow: auto;
}
</style>
